import * as React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { history } from "./store/history";
import {
  ForgotPasswordPage,
  LoginPage,
  RegisterPage,
  Error400,
  Error401,
  Error403,
  Error404,
  Error500,
  Error503,
  EmptyPage,
  Email,
  ProfilePage,
  VerifyEmailPage,
  ResetPasswordPage,
  Measure,
  ViewMeasure,
  Products,
  EditProduct,
  ViewProduct,
  Categories,
  EditCategory,
  Tags,
  EditTag,
  Users,
  UserEdit,
  MyAccount,
  CustomerProducts,
  CustomerViewProduct,
  SubscribePage,
  Tickets,
  NewTicket,
  ViewTicket,
} from "./pages";

import MeasureLogs from "./pages/MeasureLogs.react";

import PricingTable from "./pages/PricingTable";
import { PrivateRoute } from "./PrivateRoute";
import "tabler-react/dist/Tabler.css";

function App(props) {
  return (
    // <React.StrictMode>
    <Router history={history}>
      <Switch>


        <Route exact path='/login' component={LoginPage} />
        <Route exact path='/forgot-password' component={ForgotPasswordPage} />
        <Route exact path='/reset-password/:id' component={ResetPasswordPage} />
        <Route exact path='/verify-email' component={VerifyEmailPage} />
        <Route exact path='/register' component={RegisterPage} />
        <Route exact path='/register/pricing' component={PricingTable} />

        <PrivateRoute exact path='/subscribe' component={SubscribePage} roles={["Dealer"]} />
        <PrivateRoute exact path='/myaccount' component={MyAccount} roles={["Super", "Admin", "Dealer", "Customer"]} />
        <PrivateRoute exact path='/my-products' component={CustomerProducts} roles={["Customer"]} />
        <PrivateRoute exact path='/my-products/:id' component={CustomerViewProduct} roles={["Customer"]} />
        <PrivateRoute exact path='/logs' component={MeasureLogs} roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/accounts' component={EmptyPage} roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/email' component={Email} roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/profile' component={ProfilePage} roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/400' component={Error400} roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/401' component={Error401} roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/403' component={Error403} roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/404' component={Error404} roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/500' component={Error500} roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/503' component={Error503} roles={["Super", "Admin", "Dealer"]} />

        <PrivateRoute exact path='/' component={ Measure } roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/measure' component={ Measure } roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/measure/:id' component={ ViewMeasure } roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/products' component={ Products } roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/products/:id' component={ EditProduct } roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/products/view/:id' component={ ViewProduct } roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/categories' component={ Categories } roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/categories/:id' component={ EditCategory } roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/tags' component={ Tags } roles={["Super", "Admin"]} />
        <PrivateRoute exact path='/tags/:id' component={ EditTag } roles={["Super", "Admin"]} />
        <PrivateRoute exact path='/users' component={Users} roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/users/:id' component={UserEdit} roles={["Super", "Admin", "Dealer"]} />
        <PrivateRoute exact path='/tickets' component={Tickets} roles={["Super", "Admin", "Dealer", "Customer"]} />
        <PrivateRoute exact path='/tickets/new' component={NewTicket} roles={["Super", "Admin", "Dealer", "Customer"]} />
        <PrivateRoute exact path='/tickets/:id' component={ViewTicket} roles={["Super", "Admin", "Dealer", "Customer"]} />
        
        {/* <PrivateRoute exact path='/' component={EmptyPage} roles={["Super", "Admin", "Dealer"]} /> */}

        <Route component={Error404} />
      </Switch>
    </Router>
    // </React.StrictMode>
  );
}

export default App;
